import { calculateAmortizationCompound } from './common/calculateAmotizationCompound';
import { calculateAmortizationSimple } from './common/calculateAmotizationSimple';

export const calculateAmortization = ({
  creditDetails,
  setAmortizationSchedule,
  workingDayActive,
  documents,
}: {
  creditDetails: any;
  setAmortizationSchedule: any;
  workingDayActive: 'active' | 'inactive';
  documents?: any;
}) => {
  if (creditDetails.interestType === 'SIMPLE') {
    calculateAmortizationSimple({
      creditDetails,
      setAmortizationSchedule,
      workingDayActive,
      documents,
    });
  } else {
    calculateAmortizationCompound({
      creditDetails,
      setAmortizationSchedule,
      workingDayActive,
      documents,
    });
  }
};
